import { Capacitor } from "@capacitor/core";

type Portal = "app" | "central" | "franchise";

export function getPortal(): Portal {
  // The native shell never keys off the hostname (always localhost / capacitor://).
  // It selects the portal via login-time role routing instead.
  if (Capacitor.isNativePlatform()) return "app";

  const hostname = window.location.hostname;

  // Production subdomains
  if (hostname.startsWith("central.")) return "central";
  if (hostname.startsWith("franchise.")) return "franchise";

  // Local dev: central.localhost, franchise.localhost
  const parts = hostname.split(".");
  if (parts[0] === "central") return "central";
  if (parts[0] === "franchise") return "franchise";

  // Query param override for dev: ?portal=central or ?portal=franchise
  const params = new URLSearchParams(window.location.search);
  const portalParam = params.get("portal");
  if (portalParam === "central") return "central";
  if (portalParam === "franchise") return "franchise";

  return "app";
}
